import * as React from "react";
import Select from "../common/input/select";
import Text from "../common/input/text";
import { Typography, Icon } from "../ecosystem";
import * as Tools from "../../helpers/Tools";
import { log, logUI } from "../../api/andyliticsApi";

const reasonForRevisitId = 'reasonForRevisit';
const inPerson = "In Person";
const videoVisit = "Video Visit";

class VisitTypeReason extends React.Component {
    constructor(props) {
        super(props);
        const maxLength = 150;
        this.state = {
            selectedValue: "",
            reasonForVisit: "",
            showAsInvalid: false,
            validationError: "",
            visitReasonComment: "",
            maxLengthOfVisitReason: maxLength,
            chars_left: maxLength,
            isInPerson: false,
            isVideoVisit: false,
            disableVisitType: "",
            selectedValueVisitType: "",
            reasonsForVisitList: [],
            videoVisitNotes: null
        }
        this.departmentID = "";
        this.earliestCachedSlotDate = "";
        this.providerId = "";
    }
    onVisitTypeChange = (val) => {
        if (val && val.toLowerCase() === "in person") {
            this.setState({
                videoVisitNotes: null
            })
        }
        // const reasonsForVisit = this.props.visitTypeAndLocationInfo && this.props.visitTypeAndLocationInfo.reasonsForVisit;
        // const reasonForVisitOptions = reasonsForVisit && this.props.visit && reasonsForVisit.filter(val => val.accepts === this.props.visit.acceptType);
        for (let value of this.state.reasonsForVisitList) {
            if (value.visitTypeReason === this.state.reasonForVisit) {
                if (val && val.toLowerCase() === "in person") {
  
                    this.setState({ selectedValueVisitType: value.inPerson }, () => {
                        this.departmentID = value.inPersonDepartment;
                    })
                } else if (val && val.toLowerCase() === "video visit") {
                    this.setState({
                        videoVisitNotes: value.videoVisitNotes
                    })
                    this.setState({ selectedValueVisitType: value.video }, () => {
                        this.departmentID = value.videoDepartment;
                    })
                }
            }
        }

        this.setState({ selectedValue: val });
        this.setState({ showAsInvalid: false });
    }


    onInputChange = (selectValue) => {
        this.setState({
            selectedValue: "",
            videoVisitNotes: null,
           
        })
        const { isFromVideoVisitOptions } = this.props;
        const { reasonsForVisitList } = this.state;
        const reasonForVisitOptions = reasonsForVisitList && this.props.visit && reasonsForVisitList.filter(val => val.accepts === this.props.visit.acceptType);
        for (let value of reasonForVisitOptions) {
            if (value.visitTypeReason === selectValue && !isFromVideoVisitOptions) {

                // this.departmentID = value.departmentId;
                this.earliestCachedSlotDate = value.earliestCachedSlotDate;

                if (value.inPerson && value.video) {
                    this.setState({ disableVisitType: "" })

                } else {
                    let reasonValue = value.inPerson ? value.inPerson : value.video ? value.video : "";
                    this.setState({
                        disableVisitType: value.inPerson ? videoVisit : inPerson,
                        selectedValueVisitType: reasonValue,
                        //selectedValue: value.inPerson ? inPerson : videoVisit
                    })

                }
            }
            else if (value.visitTypeReason === selectValue) {
                if (value.videoVisitNotes && isFromVideoVisitOptions) {
                this.setState({
                    videoVisitNotes: value.videoVisitNotes
                });
                }
                this.earliestCachedSlotDate = value.earliestCachedSlotDate;
                this.setState({ selectedValueVisitType: value.video }, () => {
                    this.departmentID = value.videoDepartment;
                })
            }
        }
        this.setState({
            reasonForVisit: selectValue,
        })

        this.setState({ showAsInvalid: false, });

    }

    isValidate = () => {
        if ((this.state.reasonForVisit === "" || !this.state.reasonForVisit) || (
            !this.props.isFromVideoVisitOptions &&
            (this.state.selectedValue === "" || !this.state.selectedValue))
            || (this.state.visitReasonComment === "" || !this.state.visitReasonComment)) {
            this.setState({ validationError: "Please fill out all required fields." });
            return false;
        }
        return true;
    };

    isValid() {
        return this.isValidate();
    }

    onGoNext(success) {
        const { visitReasonComment, selectedValueVisitType, reasonForVisit, selectedValue} = this.state;
        const { routeTime, routeDate, isFromDotCOM} = this.props;
        if (success) {
            const visit = this.props.visit;
            const newDepartmentId = this.departmentID;
            const departmentArray = newDepartmentId && newDepartmentId.split('|');
            const departmentFilter = departmentArray && departmentArray.length > 1 ? departmentArray.filter(val => val === visit.department.id) : departmentArray;
            this.props.departmentIdArray(departmentArray);
            const loadScheduleDays = departmentArray && departmentArray.length === 1;
            visit.department.id = this.props.isFromDotCOM ? newDepartmentId : departmentFilter.toString();
            visit.isVideoVisit = (selectedValue && (videoVisit.toLowerCase() === selectedValue.toLowerCase()));
            visit.reasonForVisit = visitReasonComment;
            visit.reasonForVisitValue = reasonForVisit;
            visit.reasonVisitTypeID = selectedValueVisitType;
            // visit.visitType.startDate = isFromDotCOM ? routeDate :  this.earliestCachedSlotDate;
            visit.date = routeDate ? routeDate : "";
            visit.time = routeTime ? routeTime : "";
            // this.props.saveStepInfo({ visit: visit }, loadScheduleDays);
            // if(departmentArray.length>1){
            //  visit.visitType.startDate = this.earliestCachedSlotDate;
            // this.props.saveStepInfo({ visit: visit }, loadScheduleDays);
            // }
            // else{
            if (!isFromDotCOM && loadScheduleDays) {
                this.props.setEarliestScheduleDate(visit, (date) => {
                    visit.visitType.startDate = date ? date : isFromDotCOM ? routeDate && routeDate : this.earliestCachedSlotDate && this.earliestCachedSlotDate;

                    this.props.saveStepInfo({ visit: visit }, loadScheduleDays);
                });
            } else {
                visit.visitType.startDate = isFromDotCOM ? routeDate && routeDate : this.earliestCachedSlotDate && this.earliestCachedSlotDate;
                this.props.saveStepInfo({ visit: visit }, loadScheduleDays);
            }

            //} 
        }
        else {
            this.setState({ showAsInvalid: true });
        }
    }
    handleInputChange(e) {
        if (e) {
            const target = e.target;
            const charCount = target.value.length;
            const charLeft = this.state.maxLengthOfVisitReason - charCount;
            this.setState({ visitReasonComment: target.value, chars_left: charLeft },
                () => {
                    const valid = this.isValid();
                    if (this.valid !== valid) {
                        this.valid = valid;
                        if (this.props.isValid) {
                            this.props.isValid(valid);
                        }
                    }
                }
            );
            this.setState({ showAsInvalid: false, });
        }
    }
    componentDidUpdate(prevProp, preState) {
        const reasonsForVisit = this.props.visitTypeAndLocationInfo && this.props.visitTypeAndLocationInfo.reasonsForVisit;
        const { isFromVideoVisitOptions, visit, enableNewVideoVisitFlow, enableNewProviderSchedulingWorkflow, visitTypeAndLocationSuccess } = this.props;
        if (preState && preState.reasonsForVisitList.length !== 0) {
            this.setState({
                reasonsForVisitList: []
            })
        }
        if (visit && visit.acceptType &&
                 reasonsForVisit && reasonsForVisit.length !== 0 && ((this.state.reasonsForVisitList.length === 0) ||
                (this.state.reasonsForVisitList.length > 0 && this.state.reasonsForVisitList[0].accepts !== this.props.visit.acceptType) ||
                (isFromVideoVisitOptions && (enableNewVideoVisitFlow || enableNewProviderSchedulingWorkflow) && this.props.providerId !== this.providerId && visitTypeAndLocationSuccess))) {
            const tempReasonsForVisit = this.getReasonsForVisit();
            if ((tempReasonsForVisit && tempReasonsForVisit.length > 0) || (this.state.reasonsForVisitList && this.state.reasonsForVisitList.length > 0)) {
                this.setState({ reasonsForVisitList: tempReasonsForVisit }, () => {
                    this.providerId = this.props.providerId;
                })
            }
        }
        const reasonForVisitOptions = reasonsForVisit && this.props.visit && reasonsForVisit.filter(val => val.accepts === (this.props && this.props.visit && this.props.visit.acceptType));

        if (prevProp && this.props && prevProp.visitTypeAndLocationInfo && this.props.visitTypeAndLocationInfo && prevProp.visitTypeAndLocationInfo !== this.props.visitTypeAndLocationInfo) {
            if (reasonForVisitOptions && reasonForVisitOptions.length === 1) {
                this.onInputChange(reasonForVisitOptions[0].visitTypeReason)
            }
        }

        if (prevProp && prevProp.reasonAcceptType !== this.props.reasonAcceptType) {
            this.setState({
                reasonForVisit: "",
                disableVisitType: "",
                visitReasonComment: "",
                videoVisitNotes: null,
                chars_left: 150
            })
        }
        
       
        if (this.props.isFromDotCOM && prevProp && (prevProp.reason !== this.props.reason) || (prevProp.reasonvisitTypeID !== this.props.reasonvisitTypeID)) {
            this.onInputChange(this.props.reason);
            this.setState({ visitReasonComment: this.props.visit.reasonForVisit, chars_left: 150 - this.props.visit.reasonForVisit.length});
            this.setState({ reasonsForVisitList: this.getReasonsForVisit() }, () => {
                let filterObj = this.state.reasonsForVisitList.filter(val => val.visitTypeReason === this.props.reason && this.props.reason);
                const visitTypeFromDotcom = this.props.visit.reasonVisitTypeID;
                for (let value of filterObj) {
                    if (value.inPerson && value.inPerson === visitTypeFromDotcom) {
                        this.onVisitTypeChange(inPerson);

                    } else {
                        this.onVisitTypeChange(videoVisit);
                    }
                    if (value.inPerson && value.video) {
                        this.setState({ disableVisitType: "" })

                    } else {  
                        this.setState({
                            disableVisitType: value.inPerson ? videoVisit : inPerson
                        })

                    }
                }
            })
        }

        logUI("MBHWeb.UI.VisitTypeReason.ComponentDidUpdate", new Date(), Tools.getURLPath());
    }
    getReasonsForVisit = () => {
        let uniqueReasonsForVisit = [];
        const { visitTypeAndLocationInfo, visit, isFromVideoVisitOptions } = this.props;
        const reasonsForVisit = visitTypeAndLocationInfo && visitTypeAndLocationInfo.reasonsForVisit;
        reasonsForVisit && visit && reasonsForVisit.map((reasonForVisit) => {
            if (reasonForVisit.accepts === visit.acceptType && !isFromVideoVisitOptions) {
                let index = uniqueReasonsForVisit.map((object) => object.visitTypeReason).indexOf(reasonForVisit.visitTypeReason);
                if (index !== -1) {
                    let indexedObject = uniqueReasonsForVisit[index];
                    if (reasonForVisit.video !== null) {
                        indexedObject = {
                            ...indexedObject,
                            video: reasonForVisit.video,
                            videoDepartment: indexedObject.videoDepartment ? indexedObject.videoDepartment.split("|").concat(reasonForVisit.departmentId.split("|")).join("|") : reasonForVisit.departmentId,
                        };
                    }
                    if (reasonForVisit.inPerson !== null) {
                        indexedObject = {
                            ...indexedObject,
                            inPerson: reasonForVisit.inPerson,
                            inPersonDepartment: indexedObject.inPersonDepartment ? indexedObject.inPersonDepartment.split("|").concat(reasonForVisit.departmentId.split("|")).join("|") : reasonForVisit.departmentId,
                        };
                    }
                    uniqueReasonsForVisit[index] = indexedObject;
                }
                else {
                    uniqueReasonsForVisit.push({
                        ...reasonForVisit,
                        inPersonDepartment: reasonForVisit.inPerson ? reasonForVisit.departmentId : "",
                        videoDepartment: reasonForVisit.video ? reasonForVisit.departmentId : "",
                    });
                }
            }
            else {
                if (reasonForVisit.accepts === visit.acceptType && isFromVideoVisitOptions && reasonForVisit.video !== null) {
                    let index = uniqueReasonsForVisit.map((object) => object.visitTypeReason).indexOf(reasonForVisit.visitTypeReason);
                    if (index !== -1) {
                        let indexedObject = uniqueReasonsForVisit[index];
                        if (reasonForVisit.video !== null) {
                            indexedObject = {
                                ...indexedObject,
                                video: reasonForVisit.video,
                                videoDepartment: indexedObject.videoDepartment ? indexedObject.videoDepartment.split("|").concat(reasonForVisit.departmentId.split("|")).join("|") : reasonForVisit.departmentId,
                            };
                        }
                        uniqueReasonsForVisit[index] = indexedObject;
                    }
                    else {
                        uniqueReasonsForVisit.push({
                            ...reasonForVisit,
                            inPersonDepartment: reasonForVisit.inPerson ? reasonForVisit.departmentId : "",
                            videoDepartment: reasonForVisit.video ? reasonForVisit.departmentId : "",
                        });
                    }
                }
            }
        });
        return uniqueReasonsForVisit;
    };

    render() {
        const { isFromVideoVisitOptions, isMobile, isMyDoctor } = this.props;
        const { selectedValue, showAsInvalid, validationError, disableVisitType, reasonForVisit, visitReasonComment, reasonsForVisitList, maxLengthOfVisitReason, videoVisitNotes } = this.state;
        let reasonForVisitOptions = reasonsForVisitList.map((item, index) => { return <option key={"reasonForVisit_" + index} value={item.visitTypeReason}>{item.visitTypeReason}</option> });
        return (
            <div className="visit-reason-container sm-width-step" style={this.props.style}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="step-heading">What can we help you with today?</h1>
                    </div>
                </div>
                <div className="col-12 col-md-6 form-group visit-reason-view">
                    <Select id="reasonForVisit_select" required value={this.state.reasonForVisit}
                        onChange={e => this.onInputChange(e.target.value)}
                        renderedOptions={reasonForVisitOptions}
                        placeholder="Reason for Visit"
                        showAsInvalid={this.state.showAsInvalid && !this.state.reasonForVisit}
                    />
                </div>
                <div className="col-12 col-md-6 form-group  visit-reason-view">
                    <Text name="visitReasonComment" 
                        required
                        placeholder="Provide additional details"
                        id={reasonForRevisitId} value={this.state.visitReasonComment}
                        maxSize={maxLengthOfVisitReason}
                        onChange={(e) => this.handleInputChange(e)}
                        rows="10"
                        showAsInvalid={showAsInvalid && (!visitReasonComment || visitReasonComment === "")}
                    />
                    <div className={this.state.chars_left === 0 ? "hint-text warning" : "hint-text"}>{this.state.chars_left} - Characters Remaining </div>
                </div>

                {reasonForVisit && !isFromVideoVisitOptions && <div className="visit-reason-view">
                    <div className="sub-heading-reason-for-visit"><Typography tag={"div"} type="heading-05" bold color="$color-primary-a3">How would you like to be seen?</Typography></div>
                    <div className="col-12 visit-type-reason-container step-form-container">
                        <div className="visit-type-reason">
                            <div className="card rounded-0">
                                <div className={disableVisitType === inPerson ? "visit-type-reason-disabled-container" : `${(inPerson === selectedValue)
                                    ? "visit-type-reason-container  select-visit-type-container" :
                                    " visit-type-reason-container unselect-visit-type-container"}`
                                }>
                                    <div className="card-body">
                                        <label className="visit-type-reason-radio-btn-container">
                                            <input type="radio"
                                                disabled={disableVisitType === inPerson}
                                                value={inPerson}
                                                checked={inPerson === selectedValue}
                                                onChange={(e) => this.onVisitTypeChange(inPerson)} />
                                            <span className="visit-type-reason-radio-btn" />
                                            <div className="location-radio-label">
                                                <div className="visit-type-reason-radio-btn-label">
                                                    <Typography type="body-02"
                                                        color={disableVisitType === inPerson ? "$color-secondary-a3" : inPerson === selectedValue ? "$color-primary-a2" :
                                                            "$color-secondary-a2"}
                                                    >
                                                        {inPerson}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="visit-type-reason">
                            <div className="card rounded-0">
                                <div className={disableVisitType === videoVisit ? "visit-type-reason-disabled-container" : `${(videoVisit === selectedValue) ? "visit-type-reason-container  select-visit-type-container" : "unselect-visit-type-container visit-type-reason-container"}`}>
                                    <div className="card-body">
                                        <label className="visit-type-reason-radio-btn-container">
                                            <input type="radio" disabled={disableVisitType === videoVisit}
                                                value={videoVisit}
                                                checked={videoVisit === selectedValue}
                                                onChange={(e) => this.onVisitTypeChange(videoVisit)} />
                                            <span className="visit-type-reason-radio-btn" />
                                            <div className="location-radio-label">
                                                <div className="visit-type-reason-radio-btn-label">
                                                    <Typography type="body-02"
                                                        color={disableVisitType === videoVisit ? "$color-secondary-a3" : videoVisit === selectedValue
                                                            ? "$color-primary-a2" : "$color-secondary-a2"}
                                                    >{videoVisit}</Typography>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
                {videoVisitNotes && (
                    <div className="col-12 col-md-6 form-group visit-reason-view flex-video-visit-notes" >
                        <Icon name="alert" size="medium" />
                        <Typography>{videoVisitNotes}</Typography>
                    </div>
                )}
                {(showAsInvalid && validationError !== "") &&
                    <div className={`${isMobile || isMyDoctor ?'text-center':'text-right'} validation-error-container`}>
                        <Typography type="body-02" textAlign="center" color="$color-system-b1">{validationError}</Typography>
                    </div>
                }
            </div>
        )
    }
}
export default VisitTypeReason;